import api from "./Api";

class PagarAnexoService {
  GetPagarAnexo(payload) {
    return api.get("/v1/pagarAnexo/" + payload).then((response) => {
      return response.data;
    });
  }

  PostPagarAnexo(payload) {
    return api.post("/v1/pagarAnexo/", payload).then((response) => {
      return response.data;
    });
  }

  PutPagarAnexo(payload) {
    return api.put("/v1/pagarAnexo/", payload).then((response) => {
      return response.data;
    });
  }

  DeletePagarAnexo(payload) {
    return api.delete("/v1/pagarAnexo/" + payload).then((response) => {
      return response.data;
    });
  }

  GetPagarAnexoOData(payload) {
    return api.get("/OData/PagarAnexo" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new PagarAnexoService();
